import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumber, CountryCode, AsYouType } from 'libphonenumber-js/min';
@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(val, args) {
    try {
      const phoneNumber = new AsYouType('US').input(val);
      // const phoneNumber = parsePhoneNumber(val + '', 'US' as CountryCode);
      return phoneNumber;//.formatNational();
    } catch (error) {
      return val;
    }
}

}
